"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Slider = _interopRequireDefault(require("@material-ui/core/Slider"));
var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));
var _ProductDetailContext = _interopRequireDefault(require("../../../../ProductDetail/context/ProductDetailContext"));
var _ProductSelectionContext = _interopRequireDefault(require("../../../../ProductDetail/context/ProductSelectionContext"));
var _ShopContext = _interopRequireDefault(require("../../../../context/ShopContext"));
var _formatPrice = _interopRequireDefault(require("../../../../utils/formatPrice"));
var _PriceSlider = _interopRequireDefault(require("./PriceSlider.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var PriceSlider = function PriceSlider() {
  var _useContext = (0, _react.useContext)(_ShopContext.default),
    shopData = _useContext.shopData;
  var _ref = shopData || {},
    currency = _ref.currency,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? "de-DE" : _ref$locale;
  var _ref2 = currency || {},
    isoCode = _ref2.isoCode;
  var _useContext2 = (0, _react.useContext)(_ProductDetailContext.default),
    productDetailData = _useContext2.productDetailData;
  var _ref3 = productDetailData || {},
    _ref3$customPrice = _ref3.customPrice,
    price = _ref3$customPrice === void 0 ? {} : _ref3$customPrice;
  var _price$from = price.from,
    from = _price$from === void 0 ? 0 : _price$from,
    _price$to = price.to,
    to = _price$to === void 0 ? 100 : _price$to,
    _price$step = price.step,
    step = _price$step === void 0 ? 10 : _price$step;
  var _useContext3 = (0, _react.useContext)(_ProductSelectionContext.default),
    _useContext3$productS = _useContext3.productSelection,
    productSelection = _useContext3$productS === void 0 ? {} : _useContext3$productS,
    setProductSelection = _useContext3.setProductSelection;
  var _productSelection$cus = productSelection.customPrice,
    customPrice = _productSelection$cus === void 0 ? 0 : _productSelection$cus;
  var css = (0, _PriceSlider.default)();
  (0, _react.useEffect)(function () {
    if (from > 0) {
      setProductSelection(function (prevProductSelection) {
        return _objectSpread(_objectSpread({}, prevProductSelection), {}, {
          customPrice: from
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [from]);
  var handleChange = function handleChange(event, newValue) {
    setProductSelection(function (prevProductSelection) {
      return _objectSpread(_objectSpread({}, prevProductSelection), {}, {
        customPrice: newValue
      });
    });
  };
  var value = (0, _react.useMemo)(function () {
    return customPrice > from ? customPrice : from;
  }, [customPrice, from]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.priceSlider, "mco-shop-product-detail-voucher-selection-price-slider")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.label, "mco-shop-product-detail-voucher-selection-price-slider__label")
  }, "Gutscheinwert"), /*#__PURE__*/_react.default.createElement(_Slider.default, {
    classes: {
      root: (0, _clsx.default)(css.slider, "mco-shop-product-detail-voucher-selection-price-slider__slider")
    },
    min: from,
    max: to,
    step: step,
    track: false,
    value: value,
    onChange: handleChange
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.values, "mco-shop-product-detail-voucher-selection-price-slider__values")
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.min, "mco-shop-product-detail-voucher-selection-price-slider__min"),
    variant: "body2"
  }, (0, _formatPrice.default)(from, isoCode, locale)), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.value, "mco-shop-product-detail-voucher-selection-price-slider__value")
  }, (0, _formatPrice.default)(value, isoCode, locale)), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.max, "mco-shop-product-detail-voucher-selection-price-slider__max"),
    variant: "body2"
  }, (0, _formatPrice.default)(to, isoCode, locale))));
};
var _default = PriceSlider;
exports.default = _default;